"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MintError = exports.MintType = void 0;
var MintType;
(function (MintType) {
    MintType["KNOWN_TRACK"] = "known_track";
    MintType["RANDOM_UNREVEALED"] = "random_unrevealed";
    MintType["RANDOM_REVEALVED"] = "random_revealed";
    MintType["NFT_PACK"] = "nft_pack";
    MintType["UNKNOWN"] = "unknown";
})(MintType || (exports.MintType = MintType = {}));
var MintError;
(function (MintError) {
    MintError["NOT_FOR_SALE"] = "not for sale";
    MintError["SOLD_OUT"] = "sold out";
    MintError["SALE_NOT_STARTED"] = "sale not started";
    MintError["SALE_ENDED"] = "sale ended";
    MintError["USER_LIMIT_REACHED"] = "user limit reached";
    MintError["NOT_IN_ALLOW_LIST"] = "user not in allow list";
    MintError["MINT_LIMIT_EXCEEDED"] = "mint limit exceeded";
    MintError["PRECONDITION_NOT_MET"] = "precondition not met";
    MintError["NOT_SUPPORTED"] = "not supported";
})(MintError || (exports.MintError = MintError = {}));
